import project from './project';
import users from './user';
import harvcoTag from './harvcoTag';
import industries from './industry';
import universe from './universe';
import common from './common';
import industryPopup from './industryPopup';

const eprojectReducer = (state = {}, action) => ({
  common: common(state.common, action),
  projectData: project(state.projectData, action),
  users: users(state.users, action, state.common),
  harvcoTags: harvcoTag(state.harvcoTags, action, state.common),
  industries: industries(state.industries, action, state.common),
  universe: universe(state.universe, action),
  industryPopup: industryPopup(state.industryPopup, action),
});

export default eprojectReducer;
